import React, { useState } from 'react';
import { Card, CardHeader, CardContent, CardActions, IconButton, Button, useMediaQuery, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Icon from '../Icon/Icon';
import { useTranslation } from 'react-i18next';

const Panel = ({
    title,
    subtitle,
    titleGap,
    action,
    viewAll = "",
    quickFilterEnable = "",
    expandable = false,
    mobileCollapsible = false,
    defaultExpanded = true,
    footer,
    children,
    ...cardProps
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [expanded, setExpanded] = useState(defaultExpanded);

    const isExpandable = expandable || (mobileCollapsible && isMobile);

    const expandAction = isExpandable ? (
        <IconButton onClick={() => setExpanded(prev => !prev)}>
            <Icon icon={expanded ? 'fa-chevron-up' : 'fa-chevron-down'} />
        </IconButton>
    ) : null;

    const viewAllLink = viewAll ? (
        <Button
            component={RouterLink}
            variant="tertiary"
            size="small"
            to={`/${viewAll}`}
            state={{ isQuickFilterEnable: quickFilterEnable }}
            onClick={() => localStorage.setItem('quickFilter', JSON.stringify(quickFilterEnable))}
            onContextMenu={() => localStorage.setItem('quickFilter', JSON.stringify(quickFilterEnable))}
            data-testid="viewAll"
        >
            {t('Dashboard.viewAll')}
        </Button>
    ) : null;

    return (
        <Card className={`Panel-root${isExpandable && !expanded ? ' Panel-collapsed' : ''}`} {...cardProps}>
            {title && (
                <CardHeader
                    title={title}
                    subheader={subtitle}
                    action={action ?? expandAction}
                    titleTypographyProps={{ sx: { textTransform: 'capitalize', ...(titleGap !== undefined ? { mb: titleGap } : { mb: 1 }) } }}
                    sx={{ '& .MuiCardHeader-action': { alignSelf: 'flex-start', mt: 0.5, mr: 0, mb: 0 }, borderBottom: (isExpandable && !expanded) ? 'none' : undefined }}
                />
            )}
            {(!isExpandable || expanded) && (
                <CardContent>{children}</CardContent>
            )}
            {(footer || viewAllLink) && (
                <CardActions>
                    {footer}
                    {viewAllLink}
                </CardActions>
            )}
        </Card>
    );
};

export default Panel;
